import { createFileRoute, redirect } from "@tanstack/react-router";

// Old WordPress media/attachment page — 301 to the English front page.
export const Route = createFileRoute("/en/mi-support-logo")({
  beforeLoad: () => {
    throw redirect({ to: "/en", statusCode: 301 });
  },
});
